'use strict';

var _commonjsHelpers = require('../../../_virtual/_commonjsHelpers.js');
var index = require('../../../_virtual/index.js_commonjs-exports3.js');
require('./slider.js');
var slider = require('../../../_virtual/slider.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slider = _interopRequireDefault(slider.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _slider["default"];
exports["default"] = _default;
}(index.__exports));

var Slider = /*@__PURE__*/_commonjsHelpers.getDefaultExportFromCjs(index.__exports);

module.exports = Slider;
